import React from "react";
import { Link } from "react-router-dom";
import { AppSettings } from "./../../config/app-settings.js";
import { useTranslation } from "react-i18next";
import { useAuthStore } from "../../stores/auth";
import Spinner from "../misc/Spinner";

export default function SidebarProfile() {
  const { t } = useTranslation();
  const me = useAuthStore((state) => state.me);

  if (!me) {
    return <Spinner />;
  }

  return (
    <AppSettings.Consumer>
      {({ appSidebarMinify }) => (
        <div className="menu">
          {/*<div className="menu-profile">
            <Link
              to="/"
              onClick={handleProfileExpand}
              className="menu-profile-link"
            >
              <div className="menu-profile-cover with-shadow"></div>
              <div className="menu-profile-image menu-profile-image-icon bg-gray-900 text-gray-600">
                <i className="fa fa-user"></i>
              </div>
              <div className="menu-profile-info">
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1"><small>{me.name}</small></div>
                  <div className="menu-caret ms-auto"></div>
                </div>
              </div>
            </Link>
          </div>*/}
          <div id="appSidebarProfileMenu" className="collapse">
            <div className="menu-item pt-5px">
              <Link to="/" className="menu-link">
                <div className="menu-icon">
                  <i className="fa fa-cog"></i>
                </div>
                <div className="menu-text">{t("menu.settings")}</div>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/" className="menu-link">
                <div className="menu-icon">
                  <i className="fa fa-pencil-alt"></i>
                </div>
                <div className="menu-text">{t("menu.feedback")}</div>
              </Link>
            </div>
            <div className="menu-item pb-5px">
              <Link to="/" className="menu-link">
                <div className="menu-icon">
                  <i className="fa fa-question-circle"></i>
                </div>
                <div className="menu-text">{t("menu.help")}</div>
              </Link>
            </div>
            <div className="menu-divider m-0"></div>
          </div>
        </div>
      )}
    </AppSettings.Consumer>
  );
}
